import React from 'react';
import Summary from 'Components/Summary/Summary';
import Totalrate from '../../Assets/elvotaimages/Totalrate.svg';
import Additionalper from '../../Assets/elvotaimages/Additionalper.svg';

export default function Energymangment() {
  const summaryContent = [
    'The United States offers exceptional incentives for renewable energy projects, with programs covering up to 50% of CAPEX costs. This strong financial support makes it an attractive market for developers and investors.',
    'The Texas market is also at the forefront of energy storage development, leading globally with rapid advancements and a growing emphasis on grid stability and efficiency.',
    'With its high energy price volatility, the Texas market provides an ideal environment for energy storage solutions, enabling significant profitability and opportunities for innovation.',
  ];
  return (
    <div className="pb-[120px]">
      <div className="main-container">
        <div>
          <h1 className="heading-spacing f-f-b text-[50px] ">
            Our strategic entry point:
            <span className="text-green-dark">Texas</span>
          </h1>
        </div>
        <Summary paragraph={summaryContent} />

        <div className="grid grid-cols-12 mt-10 sm:mt-[60px] md:mt-[100px] lg:mt-[120px] sm:gap-10 xl:gap-[100px] ">
          <div className="col-span-12 xl:col-span-6">
            <h1 className="f-f-b-ex text-black text-[18px] md:text-[22px] text-center ">
              Total rated power of operational battery energy storage in Texas
            </h1>

            <img
              src={Totalrate}
              className=" w-10/12 mx-auto xl:ml-0 xl:w-full h-auto xl:h-[277px] mt-5"
              alt=""
            />
          </div>

          <div className="col-span-12 xl:col-span-6">
            <h1 className="f-f-b-ex text-black text-[18px] md:text-[23px] text-center mt-10 xl:mt-0 ">
              <span className="text-green-light">44%</span> additional revenue
              when capturing the top
              <span className="text-green-light"> 1% peaks</span> in electricity
              prices.
            </h1>

            <img
              src={Additionalper}
              className="w-10/12 mx-auto xl:ml-0 xl:w-full h-auto xl:h-[277px] mt-5"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}
